module.exports = __webpack_public_path__ + "static/media/andrewnock-b.37410a36.png";